<template>
  <div class="common-form-inline page-main no-shadow">
    <a-form-model
      :model="pageData"
      :label-col="{ span: 10 }"
      :wrapper-col="{ span: 7 }"
    >
      <a-form-model-item label="企业名称" prop="cstNm">
        <a-input v-model="pageData.cstNm" disabled />
      </a-form-model-item>

      <a-form-model-item label="社会信用代码" prop="orgCode">
        <a-input v-model="pageData.orgCode" disabled />
      </a-form-model-item>

      <a-form-model-item label="收款账户" prop="accountNo">
        <a-input v-model="pageData.accountNo" disabled />
      </a-form-model-item>

      <a-form-model-item label="账户户名" prop="accountName">
        <a-input v-model="pageData.accountName" disabled />
      </a-form-model-item>

      <a-form-model-item label="开户银行" prop="accountBank">
        <a-input v-model="pageData.accountBank" disabled />
      </a-form-model-item>

      <a-form-model-item label="大额行号" prop="largeBankNo">
        <a-input v-model="pageData.largeBankNo" disabled />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { bindingAccountList } from "@/api/customer.js";
export default {
  components: {},
  data() {
    return {
      pageData: {
        cstNm: this.$store.getters["home/getUserObj"].cstNm,
        orgCode: this.$store.getters["home/getUserObj"].orgCode,
        accountName:undefined,
        accountNo: undefined,
        accountBank: undefined,
        largeBankNo: undefined
      },
    }
  },
  computed: {

  },
  methods: {
    init(){
      this.pageData.cstNm = this.$store.getters["home/getUserObj"].cstNm;
      this.pageData.orgCode = this.$store.getters["home/getUserObj"].orgCode;
      this.pageData.accountName = this.$route.query.accountName;
      this.pageData.accountNo = this.$route.query.accountNo;
      this.pageData.accountBank = this.$route.query.accountBank;
      this.pageData.largeBankNo = this.$route.query.largeBankNo;
    },
    check() {
      return new Promise((resolve, reject) => {
        resolve()
      });
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bank/bank-info-base.vue